import Cookies from 'js-cookie'

const userToken = 'UserToken'
const historyToken = 'HistoryToken'
const boxToken = 'BoxToken'

export function getBoxInfo() {
  let history = Cookies.get(boxToken)
  if (history !== null && history !== undefined) {
    return JSON.parse(history)
  }
  return []
}
export function updateBoxInfo(box) {
  var boxInfo = getBoxInfo()
  if (boxInfo === null) {
    Cookies.set(boxToken, JSON.stringify([box]))
  } else {
    let temps = [box]
    boxInfo.forEach((value) => {
      if (value.code !== box.code && temps.length <= 4) {
        temps.push(value)
      }
    })
    Cookies.set(boxToken, JSON.stringify(temps))
  }
}
export function getHistoryInfo() {
  let history = Cookies.get(historyToken)
  if (history !== null && history !== undefined) {
    return JSON.parse(history)
  }
  return []
}
export function removeHistoryInfo(contractNumber) {
  var historyInfo = getHistoryInfo()
  if (historyInfo !== null) {
    let temps = []
    historyInfo.forEach((value, index) => {
      if (value.contractNumber !== contractNumber) {
        temps.push(value)
      }
    })
    if (historyInfo.length > 0) {
      Cookies.set(historyToken, JSON.stringify(temps))
    } else {
      Cookies.set(historyToken, null)
    }
  }
}
export function updateHistoryInfo(history) {
  var historyInfo = getHistoryInfo()
  if (historyInfo === null) {
    Cookies.set(historyToken, JSON.stringify([history]))
  } else {
    let temps = [history]
    historyInfo.forEach((value) => {
      if (value.contractNumber !== history.contractNumber && temps.length <= 4) {
        temps.push(value)
      }
    })
    Cookies.set(historyToken, JSON.stringify(temps))
  }
}
export function getUserInfo() {
  let userInfo = Cookies.get(userToken)
  if (userInfo !== null && userInfo !== undefined) {
    return JSON.parse(userInfo)
  }
  return null
}
export function setUserInfo(userInfo) {
  return Cookies.set(userToken, JSON.stringify(userInfo))
}
export function removeUserInfo() {
  return removeCookie(userToken)
}
export function removeCookie(token) {
  return Cookies.remove(token)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js